"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { captureOpenAIReference } from "../../lib/openaiAttribution";

// No UI or third-party script. Mounted only when server-side rollout is enabled.
export default function OpenAIAttribution() {
  const pathname = usePathname();
  useEffect(() => { captureOpenAIReference(); }, [pathname]);
  return null;
}
